import { authorizedApi } from '@/utils/apiUtils';

export const allAppointmentsLink = `${
  import.meta.env.VITE_BOOKINGS_APP_URL
}/id/${authorizedApi.defaults.headers.id}`;
